export const UserForgotPass = {
	url: '/forgotpassword?token',
	title: 'Forgot Password',
	template: '<forgot-pass-page></forgot-pass-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "forgotPasswordPageMod" */
			'@Containers/user-forgot-pass-page/user-forgot-pass-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
